import { render, staticRenderFns } from "./DetalhesRelatorioLRFCI.vue?vue&type=template&id=ec4bcb0a&scoped=true"
import script from "./DetalhesRelatorioLRFCI.vue?vue&type=script&lang=ts"
export * from "./DetalhesRelatorioLRFCI.vue?vue&type=script&lang=ts"
import style0 from "./DetalhesRelatorioLRFCI.vue?vue&type=style&index=0&id=ec4bcb0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4bcb0a",
  null
  
)

export default component.exports